var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 307.93 373.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#9b9b9c;stroke-miterlimit:10;stroke-width:9px;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "medaille-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.73 100.7 197.43 4.5 298.53 4.5 206.63 118.8 106.13 115.5 110.73 100.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "110.73 112.2 14.83 4.5 102.93 4.5 197.43 112.2 110.73 112.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60.73,
    y1: 4.5,
    x2: 146.73,
    y2: 108.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 245.73,
    y1: 4.5,
    x2: 163.23,
    y2: 105.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "151.73 81.2 171.03 75 188.13 86 208.33 85 222.03 100 241.83 104.4 251.13 122.4 269.13 131.7 273.53 151.5 288.53 165.2 287.53 185.4 298.53 202.5 292.33 221.8 298.53 241.1 287.53 258.2 288.53 278.5 273.53 292.1 269.13 311.9 251.13 321.2 241.83 339.2 222.03 343.6 208.33 358.6 188.13 357.6 171.03 368.6 151.73 362.4 132.43 368.6 115.33 357.6 95.13 358.6 81.43 343.6 61.63 339.2 52.33 321.2 34.33 311.9 29.93 292.1 14.93 278.5 15.93 258.2 4.93 241.1 11.13 221.8 4.93 202.5 15.93 185.4 14.93 165.2 29.93 151.5 34.33 131.7 52.33 122.4 61.63 104.4 81.43 100 95.13 85 115.33 86 132.43 75 151.73 81.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 151.73,
    cy: 221.8,
    r: 113.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "224.43 202.9 174.33 194.8 152.53 148.9 129.33 194.1 79.03 200.6 114.83 236.6 105.43 286.5 150.73 263.6 195.33 287.9 187.53 237.7 224.43 202.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedals);
export default __webpack_public_path__ + "static/media/medals.3caa31b88bffd10b8a6fc0dfd6c58c85.svg";
export { ForwardRef as ReactComponent };